import { differenceInCalendarDays, endOfWeek } from '@chilipiper/date-time'
import { BuildBaseRequest, BaseRequest } from '../types'

export const buildRequestBase = ({
  intervalDuration,
  intervalStartsAt,
  meetingTypeId,
  meetingTypeVersion = new Date().toISOString(),
  afterBufferDurationOverride,
  beforeBufferDurationOverride,
  meetingDurationOverride,
}: BuildBaseRequest): BaseRequest => {
  return {
    intervalStartsAt: intervalStartsAt,
    availabilityEndsAt: intervalStartsAt,
    interval: {
      duration: intervalDuration,
      startsAt: intervalStartsAt,
    },
    meetingTypeRef: {
      id: meetingTypeId,
      timestamp: meetingTypeVersion,
    },
    meetingTypeOverride: {
      meetingDurationOverride: meetingDurationOverride,
      beforeBufferDurationOverride: beforeBufferDurationOverride,
      afterBufferDurationOverride: afterBufferDurationOverride,
    },
  }
}

export const getInitialInterval = (date: string) => {
  const initialDate = new Date(date)
  const INCLUDE_TODAY = 1
  const interval = differenceInCalendarDays(endOfWeek(initialDate), initialDate) + INCLUDE_TODAY
  return `${interval} days`
}
